module.exports = __webpack_public_path__ + "img/appAsset-brand--oneclick.cf787557.svg";